export default __webpack_public_path__ + "static/media/editVector.f128ec21.png";